import Styled from 'styled-components';

const ReviewsContainer = Styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #E9E9E9;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 0 16px 8px 16px;
`;

const LoadingContainer = Styled(ReviewsContainer)`
  > div {
    > div {
      position: relative;
    }
  }
`;

const TextBox = Styled.div`
  width: 100%;
  padding: 12px 8px;
  display: flex;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.xs};
  border-right: 1px solid #E9E9E9;
  border-left: 1px solid #E9E9E9;
`;
const FilteredEmpty = Styled.div`
border-bottom:1px solid #E9E9E9`;

export { ReviewsContainer, LoadingContainer, TextBox, FilteredEmpty };
